export type OfferRuleFamily = 'offerSet' | 'dollarDiscount' | 'agedInventory';
export type OfferRuleAgeBucketDiscountType = 'dollar' | 'percentage';

export interface OfferRuleAgeBucket {
  minAgeDays: number;
  maxAgeDays: number | null;
  discountType: OfferRuleAgeBucketDiscountType;
  discountValue: number | null;
}

export class OfferRuleModel {
  id?: number;
  accountId: number;
  offerSetId?: number;
  year?: number;
  make?: string;
  model?: string;
  trim?: string;
  minSalePrice?: number;
  maxSalePrice?: number;
  vehicleLimit?: number;
  vehicleCondition?: string;
  dollarAmountDiscount?: number;
  percentageDiscount?: number;
  discountBasis?: 'selling_price' | 'msrp';
  offerRuleType?: OfferRuleFamily;
  maxDiscountAmount?: number | null;
  ageBuckets?: OfferRuleAgeBucket[];
  isPrivate?: boolean;
  status?: string;
  created?: string;
  modified?: string;
}
